import { TRootState, TUsersState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { usersAdapter } from './adapter'

const selectState = (state: TRootState): TUsersState => state.users

const adapterSelectors = usersAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

export const selectors = {
    ...adapterSelectors,
    fetchStatus
}